import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupsIcon from "@mui/icons-material/Groups";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import { Box, Button, Card, CardContent, Grid, Typography, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { playerDisplayName } from "./players/PlayerDisplayNameLink";
var paths = [
    {
        icon: _jsx(EmojiEventsIcon, { sx: { fontSize: 48, color: "primary.main" } }),
        title: "League Admin",
        description: "I run a league and need to manage fixtures, standings, and teams.",
        cta: "Create a League",
        to: "/leagues/create/",
    },
    {
        icon: _jsx(GroupsIcon, { sx: { fontSize: 48, color: "primary.main" } }),
        title: "Team Manager",
        description: "I manage a team and want to track matches, stats, and players.",
        cta: "Create a Team",
        to: "/teams/create/",
    },
    {
        icon: _jsx(SportsSoccerIcon, { sx: { fontSize: 48, color: "primary.main" } }),
        title: "Player",
        description: "I'm a player and want to join a team and track my performance.",
        cta: "Find a Team",
        to: "/search/teams",
    },
];
export var Welcome = function (_a) {
    var player = _a.player;
    var navigate = useNavigate();
    var name = playerDisplayName(player);
    return (_jsxs(Box, { sx: { textAlign: "center", py: { xs: 4, sm: 6 } }, children: [_jsxs(Typography, { variant: "h4", component: "h1", sx: { fontWeight: 700, mb: 1 }, children: ["Welcome to Log.Soccer", name ? ", ".concat(name) : "", "!"] }), _jsx(Typography, { variant: "h6", color: "text.secondary", sx: { mb: 5, fontWeight: 400 }, children: "What brings you here?" }), _jsx(Grid, { container: true, spacing: 3, justifyContent: "center", children: paths.map(function (path) { return (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, children: _jsx(Card, { variant: "outlined", sx: {
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            transition: "box-shadow 0.2s",
                            "&:hover": { boxShadow: 4 },
                        }, children: _jsxs(CardContent, { sx: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                flexGrow: 1,
                                pt: 4,
                                pb: 3,
                                px: 3,
                            }, children: [path.icon, _jsx(Typography, { variant: "h6", sx: { fontWeight: 700, mt: 2, mb: 1 }, children: path.title }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 3, flexGrow: 1 }, children: path.description }), _jsx(Button, { variant: "contained", color: "primary", fullWidth: true, onClick: function () { return navigate(path.to); }, children: path.cta })] }) }) }, path.title)); }) })] }));
};
